import React from 'react';
import {connect} from "react-redux";

import QuestionPoint from "./QuestionPoint";
import PropTypes from "prop-types";

const coordinates = [
    {x: 23, y: 126 },
    {x: 150, y: 124 },
    {x: 14, y: 80 },
    {x: 50, y: 48 },
    {x: 188, y: 85 },
    {x: 121, y: 207 },
    {x: 116, y: 159 },
    {x: 142, y: 78 },
    {x: 61, y: 96 },
    {x: 170, y: 39 },
    {x: 105, y: 111 },
    {x: 76, y: 190 },
    {x: 162, y: 173 },
    {x: 30, y: 173 },
    {x: 69, y: 143 }
];

const Education = (props) => {
    return (
        <svg viewBox="0 0 260 260">
            <g className="education">
                <g className="points">
                    <circle fill="#FFFFFF" cx="47.9" cy="36.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="38.4" cy="45.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="29.8" cy="55.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="22.3" cy="66" r="1.2"/>
                    <circle fill="#FFFFFF" cx="16" cy="77.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="10.9" cy="89.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="7.1" cy="101.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="4.5" cy="114.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="3.4" cy="127.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="3.5" cy="140.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="5.1" cy="153.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="7.9" cy="165.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="12.1" cy="178" r="1.2"/>
                    <circle fill="#FFFFFF" cx="17.5" cy="189.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="24.2" cy="200.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="31.9" cy="211.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="40.7" cy="220.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="50.5" cy="229.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="61.1" cy="236.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="72.4" cy="243.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="84.3" cy="248.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="96.7" cy="252.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="109.4" cy="254.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="122.3" cy="255.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="135.3" cy="255.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="148.1" cy="254.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="160.8" cy="251.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="173.1" cy="247.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="184.8" cy="241.6" r="1.2"/>
                    <circle fill="#FFFFFF" cx="196" cy="235" r="1.2"/>
                    <circle fill="#FFFFFF" cx="206.4" cy="227.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="215.9" cy="218.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="224.4" cy="208.7" r="1.2"/>
                    <circle fill="#FFFFFF" cx="231.9" cy="198.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="238.2" cy="186.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="243.3" cy="174.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="247.2" cy="162.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="249.7" cy="149.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="250.9" cy="136.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="250.7" cy="123.9" r="1.2"/>
                    <circle fill="#FFFFFF" cx="249.2" cy="111" r="1.2"/>
                    <circle fill="#FFFFFF" cx="246.3" cy="98.4" r="1.2"/>
                    <circle fill="#FFFFFF" cx="242.1" cy="86.1" r="1.2"/>
                    <circle fill="#FFFFFF" cx="236.7" cy="74.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="230.1" cy="63.2" r="1.2"/>
                    <circle fill="#FFFFFF" cx="222.3" cy="52.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="213.5" cy="43.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="203.7" cy="34.8" r="1.2"/>
                    <circle fill="#FFFFFF" cx="193.2" cy="27.3" r="1.2"/>
                    <circle fill="#FFFFFF" cx="181.8" cy="21" r="1.2"/>
                    <circle fill="#FFFFFF" cx="69.4" cy="22.5" r="1.2"/>
                    <circle fill="#FFFFFF" cx="58.3" cy="29.1" r="1.2"/>
                    <path fill="#FFFFFF" d="M86.7,12.9l2.1-0.7l0.1,0.5c0.1,0.3,0.2,0.5,0.4,0.7c0.2,0.2,0.5,0.2,0.7,0.1c0.5-0.1,0.7-0.5,0.5-1.2
                    l-1.3-4.2l-2.3,0.7l-0.6-1.8l4.5-1.4l1.9,6c0.6,1.9-0.6,3.3-2.1,3.7c-1.5,0.4-3.2,0-3.8-1.9L86.7,12.9z"/>
                    <path fill="#FFFFFF" d="M97.4,9.2L97.4,9.2L97.5,9c-0.1-0.5-0.6-0.6-1.1-0.5c-0.8,0.2-1.6,1-1.6,1l-1.1-1.3
                    c0.7-0.7,1.5-1.2,2.5-1.5c1.8-0.4,3.1,0.3,3.5,1.9l1,3.9l-2,0.5l-0.1-0.4c0-0.1-0.1-0.3-0.1-0.4h0c0,0-0.2,1-1.6,1.4
                    c-1.2,0.3-2.4-0.3-2.7-1.5C93.8,10.3,96.5,9.4,97.4,9.2z M97.1,11.9c0.6-0.1,0.9-0.9,0.8-1.4l0-0.1l-0.2,0
                    c-0.7,0.2-1.4,0.6-1.3,1.1C96.4,11.8,96.7,12,97.1,11.9L97.1,11.9z"/>
                    <path fill="#FFFFFF"
                          d="M104,2.7l2.1-0.4l0.3,1.7l-2.1,0.4L104,2.7z M104.4,5.2l2.2-0.4l1.1,6.5l-2.2,0.4L104.4,5.2z"/>
                    <path fill="#FFFFFF" d="M114.9,3.6c1.9-0.2,3.2,1.1,3.3,2.9c0,0.2,0,0.7,0,0.7l-4.1,0.4c0.2,0.8,0.9,1.1,1.6,1
                    c0.9-0.1,1.7-0.8,1.7-0.8l1,1.5c-0.7,0.7-1.7,1.1-2.7,1.2c-2.3,0.2-3.8-1.3-3.9-3.1C111.7,5.5,112.8,3.8,114.9,3.6z M116,6.1
                    c0-0.5-0.4-0.9-1-0.9c-0.6,0.1-0.9,0.5-1,1L116,6.1z"/>
                    <path fill="#FFFFFF" d="M122.2,3.1c1.3,0,1.7,0.5,1.7,0.5h0c0,0,0-0.1,0-0.3l-0.1-2.6l2.2-0.1l0.3,9.1l-2.1,0.1l0-0.4
                    c0-0.2,0-0.4,0-0.4h0c0,0-0.5,1-1.9,1c-1.8,0.1-3-1.3-3.1-3.3C119.3,4.6,120.5,3.2,122.2,3.1z M122.9,8.2c0.7,0,1.3-0.5,1.2-1.7
                    c0-0.8-0.5-1.6-1.3-1.5c-0.7,0-1.3,0.6-1.2,1.6C121.6,7.6,122.1,8.2,122.9,8.2L122.9,8.2z"/>
                    <path fill="#FFFFFF" d="M128.2,3.2l2.2,0.1l-0.1,3.9c0,0.6,0.2,0.9,0.7,0.9c0.9,0,1.4-0.8,1.5-1.8l0.1-2.9l2.2,0.1l-0.2,6.6
                    l-2.1-0.1l0-0.6c0-0.1,0-0.3,0-0.4h0c-0.4,0.7-1.2,1.1-2.1,1.1c-1.3,0-2.3-0.7-2.3-2.5L128.2,3.2z"/>
                    <path fill="#FFFFFF" d="M136.9,1l2.2,0.2l-0.5,4.7l0.6,0.1l1.5-2l2.4,0.2l-2.2,2.8v0l1.8,3.8l-2.5-0.2l-1.1-2.7l-0.7-0.1l-0.2,2.5
                    l-2.2-0.2L136.9,1z"/>
                    <path fill="#FFFFFF" d="M147.4,7.3L147.4,7.3l0.1-0.1c0.1-0.5-0.3-0.8-0.8-0.9c-0.8-0.1-1.9,0.3-1.9,0.3L144.3,5
                    c0.9-0.4,1.9-0.6,2.9-0.4c1.8,0.3,2.8,1.5,2.5,3.1l-0.6,4l-2-0.3l0.1-0.4c0-0.1,0.1-0.3,0.1-0.4h0c0,0-0.6,0.9-2,0.7
                    c-1.2-0.2-2.1-1.2-1.9-2.4C143.6,6.9,146.4,7.2,147.4,7.3z M146.1,9.7c0.6,0.1,1.2-0.4,1.3-1l0-0.1l-0.2,0c-0.7-0.1-1.5,0-1.6,0.5
                    C145.5,9.4,145.6,9.6,146.1,9.7L146.1,9.7z"/>
                    <path fill="#FFFFFF" d="M155.1,6.1c1.7,0.4,2.3,1.5,2.3,1.5l-1.2,1.2c-0.3-0.5-0.8-0.8-1.4-1c-1-0.2-1.7,0.4-1.9,1.2
                    c-0.2,0.8,0.2,1.7,1.3,1.9c0.9,0.2,1.9-0.4,1.9-0.4l0.5,1.7c0,0-1.2,0.8-3,0.5c-2.3-0.5-3.2-2.4-2.8-4.1
                    C151.2,7,152.8,5.6,155.1,6.1z"/>
                    <path fill="#FFFFFF" d="M161.2,7.8l-1.7,6.5c-0.6,2.1-2.6,1.9-3.6,1.6c-0.2,0-0.4-0.1-0.6-0.2l0.5-1.8c0,0,0.1,0,0.3,0.1
                    c0.4,0.1,1.2,0.2,1.4-0.5l1.7-6.3L161.2,7.8z M159.8,4.8l2.1,0.6L161.4,7l-2.1-0.6L159.8,4.8z"/>
                    <path fill="#FFFFFF" d="M165.5,11.7L165.5,11.7l0.1-0.1c0.2-0.5-0.2-0.8-0.7-1c-0.8-0.3-1.9,0.1-1.9,0.1l-0.3-1.7
                    c0.9-0.3,1.9-0.3,2.9,0c1.8,0.6,2.5,1.9,2,3.4l-1.2,3.9l-1.9-0.6l0.1-0.4c0-0.1,0.1-0.3,0.1-0.4l0,0c0,0-0.7,0.8-2.1,0.4
                    c-1.2-0.4-1.9-1.4-1.5-2.7C161.8,10.7,164.6,11.4,165.5,11.7z M163.8,13.8c0.5,0.2,1.2-0.3,1.4-0.8l0-0.1l-0.2-0.1
                    c-0.7-0.2-1.5-0.3-1.7,0.3C163.3,13.4,163.4,13.7,163.8,13.8L163.8,13.8z"/>
                </g>
            </g>
            { props.survey.map((question, index) => {
                return <QuestionPoint key={question.id} code={question.code} area="education" percent={question.answers[0].percent}
                                      x={coordinates[index].x} y={coordinates[index].y}/>
            }) }
        </svg>
    );
};

const mapStateToProps = (state) => {
    return {
        survey: state.survey.education.questions,
    }
};

export default connect(mapStateToProps)(Education);

Education.defaultProps = {
    click: () => {
    },
};

Education.propTypes = {
    click: PropTypes.func,
};


// WEBPACK FOOTER //
// ./sources/js/components/Summary/graph/Education.js